/*eslint-disable*/
import React, { useState } from "react";
import Body from "./Body";

const Expences = () => {
  const [donutChartData, setDonutChartData] = useState([
    {
      categories: "Payments",
      contribution: 28.6,
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(20, 184, 166, 0.56)",
    },
    {
      categories: "Dividents",
      contribution: 42.9,
      appearanceCount: 22,
      totalAttendee: 30,
      positionColor: "rgba(59, 130, 246, 0.56)",
    },
    {
      categories: "Educational Materials",
      contribution: 28.6,
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(99, 102, 241, 0.56)",
    },
    {
      categories: "Office Supplies",
      contribution: 28.6,
      appearanceCount: 12,
      totalAttendee: 30,
      positionColor: "rgba(236, 72, 153, 0.56)",
    },
    {
      categories: "Electricity",
      contribution: 14.3,
      appearanceCount: 7,
      totalAttendee: 30,
      positionColor: "rgba(245, 158, 11, 0.56)",
    },
    {
      categories: "Activities",
      contribution: 14.3,
      appearanceCount: 7,
      totalAttendee: 30,
      positionColor: "rgba(250, 204, 21, 0.56)",
    },
  ]);

  const [lineChartData, setLineChartData] = useState([
    {
      name: "Jan",
      expenses: 4000,
    },
    {
      name: "Feb",
      expenses: 3000,
    },
    {
      name: "Mar",
      expenses: 2000,
    },
    {
      name: "Apr",
      expenses: 2780,
    },
    {
      name: "May",
      expenses: 1890,
    },
    {
      name: "Jun",
      expenses: 2390,
    },
    {
      name: "Jul",
      expenses: 3490,
    },
    {
      name: "Aug",
      expenses: 2000,
    },
    {
      name: "Sept",
      expenses: 2780,
    },
    {
      name: "Oct",
      expenses: 1890,
    },
    {
      name: "Nov",
      expenses: 2390,
    },
    {
      name: "Dec",
      expenses: 3490,
    },
  ]);

  const [expenseData, setExpenseData] = useState([
    { name: "Salaries", expenses: 3600000, changeRate: "+3.4" },
    { name: "Electric", expenses: 3600000, changeRate: "+3.4" },
    { name: "Tools", expenses: 3600000, changeRate: "+3.4" },
    { name: "Food", expenses: 3600000, changeRate: "+3.4" },
    { name: "Drinking water", expenses: 3600000, changeRate: "+3.4" },
  ]);

  const _this = {
    donutChartData,
    lineChartData,
    expenseData,
  };
  return <Body {..._this} />;
};

export default Expences;
